import './lnvLedger.css';
import jwt from 'jwt-decode';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import * as React from 'react';
import { Container, Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, Grid, FormControl, TextField, CardContent } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import { authKey, GET_INVENTORY_LEDGER_DETAILS } from '../../../common/URLs';
import { useState, useEffect } from "react";

import { loaderService } from "../../../common/custom-loader/loader-service";
import { toast } from 'react-toastify';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from "react-i18next";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { SearchIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function LnvLedger() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');
  const decoded = jwt(getLocalStorageItem('id_token'))
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [pickUpdate, setPickUpDate] = React.useState(new Date());
  const [inventoryLedgerDetails, setInventoryLedgerDetails] = useState();
  const [searchFilter, setSearchFilter] = useState({
    "inventoryFromDate": fromDate,
    "inventoryToDate": toDate,
    // "materialtype":""
  });


  const columns = [
    {
      field: 'inventoryDate', headerName: t('reg.date'), width: 120,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'stakeholderType', headerName: 'Entity Type.', width: 150 },

    { field: 'stakeholderUrn', headerName: 'Entity URN', width: 150 },

    { field: 'materialType', headerName: 'Material Type .', width: 150 },

    { field: 'bundleId', headerName: 'Bundle ID', width: 300 },

    { field: 'materialCategory', headerName: 'Category.', width: 150 },

    { field: 'inventoryCategory', headerName: 'Inventory Category.', width: 200 },

    { field: 'weight', headerName: 'Weight', width: 100 },

    { field: 'mositure', headerName: 'Moisture', width: 100 },

    { field: 'uom', headerName: 'UOM.', width: 100 },

    { field: 'orderType', headerName: 'Order Type', width: 200 },

    { field: 'orderNo', headerName: 'Order No', width: 200 },

  ];

  useEffect(() => {
    getInventoryLedgerDeatils();
  },
    []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    getInventoryLedgerDeatils(newValue);
  };

  const getInventoryLedgerDeatils = (materialType) => {
    loaderService.showLoader();
    apiClient
      .post(GET_INVENTORY_LEDGER_DETAILS,
        {

          // "inventoryFromDate": searchFilter?.fromDate ? searchFilter?.fromDate : null,
          // "inventoryToDate": searchFilter?.toDate ? searchFilter?.toDate : null
          "materialType": materialType ? materialType : tabValue,
          "inventoryFromDate": fromDate,
          "inventoryToDate": toDate,
          "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : "",

        },

        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setInventoryLedgerDetails(response.data.inventoryLedgerList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  // const handleChange = (e) => {
  //   if (e.target.name === "inventoryFromDate" || e.target.name === "inventoryToDate") {
  //     setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
  //   }
  // }

  const handleFromDateChange = (e) => {
    setFromDate(e.format("YYYY-MM-DD"));
  }

  const handleToDateChange = (e) => {
    setToDate(e.format("YYYY-MM-DD"));
  }

  function searchByDate() {
    getInventoryLedgerDeatils();
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT21</p>}
        <Typography variant="h4" sx={{ mb: 2 }}>
          Inventory Ledger
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={2} >
              <Grid item xs={12} lg={4}>
                <FormControl fullWidth >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Scheduled from"
                      inputFormat="DD/MM/YYYY"
                      name="inventoryFromDate"
                      value={fromDate}
                      onChange={(e) => { handleFromDateChange(e) }}
                      renderInput={(params) => <TextField size="small" {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4}>
                <FormControl fullWidth >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Scheduled to"
                      inputFormat="DD/MM/YYYY"
                      name="inventoryToDate"
                      value={toDate}
                      onChange={(e) => { handleToDateChange(e) }}
                      renderInput={(params) => <TextField size="small" {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Button startIcon={<SearchIcon />} variant='contained' onClick={searchByDate}>
                  Search
                </Button>
              </Grid>
            </Grid>
            <TabContext value={tabValue} mt={2}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange}>
                  <Tab label="Raw Bamboo" value="RawBamboo" />
                  <Tab label="Chip Bamboo" value="ChipBamboo" />
                </TabList>
              </Box>
              <TabPanel value="RawBamboo">
                <Box style={{ height: 400, width: '100%', marginTop: '2vh' }}>
                  {
                    inventoryLedgerDetails &&
                    <DataGrid rows={inventoryLedgerDetails}
                      columns={columns}
                      pageSize={10}
                      components={{ Toolbar: QuickSearchToolbar }}
                    />
                  }

                </Box>
              </TabPanel>
              <TabPanel value="ChipBamboo">
                <Box style={{ height: 400, width: '100%', marginTop: '2vh' }}>
                  {
                    inventoryLedgerDetails &&
                    <DataGrid rows={inventoryLedgerDetails}
                      columns={columns}
                      pageSize={10}
                      components={{ Toolbar: QuickSearchToolbar }}
                    />
                  }

                </Box>
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>


      </Container>
    </>
  )
}
export default LnvLedger;